import axios from "axios";
import { NotificationManager } from "react-notifications";
import moment from "moment";

export async function getReportSheet({
  callbackToChangeState = () => {},
  url,
  body = {},
  reportId,
  method = "POST",
  signal = null,
  cancelToken = null,
}) {
  try {
    callbackToChangeState(true);

    const res = await axios({
      method,
      url,
      data: body,
      responseType: "arraybuffer",
      signal,
      ...(cancelToken ? { cancelToken } : {}),
    });

    const filename = `DZ${reportId}_${moment().format("DD_MM_YYYY_HH_mm")}.xlsx`;

    const blob = new Blob([res.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = blobUrl;
    link.setAttribute("download", filename);

    document.body.appendChild(link);
    link.click();

    window.URL.revokeObjectURL(blobUrl);
    link.remove();

    NotificationManager.success(`Pobrano raport: DZ${reportId}`, "Sukces", 5000);

    return {
      canceled: false,
      success: true,
    };
  } catch (err) {
    const isCanceled =
      err?.code === "ERR_CANCELED" ||
      err?.name === "CanceledError" ||
      axios.isCancel?.(err) ||
      signal?.aborted;

    if (isCanceled) {
      return {
        canceled: true,
        success: false,
      };
    }

    const status = err?.response?.status;
    const msg = err?.response?.data?.message;

    if (msg === "jwt malformed") {
      window.location.reload();
    } else if (status === 403) {
      NotificationManager.warning(
        "Brak uprawnień do wykonania raportu.",
        "Błąd",
        5000
      );
    } else {
      NotificationManager.error(
        "Problem z wygenerowaniem raportu",
        "Błąd",
        5000
      );
    }

    return {
      canceled: false,
      success: false,
      error: err,
    };
  } finally {
    callbackToChangeState(false);
  }
}